/** Shared URLs and UI helpers for available-rides / marketing surfaces */

export const DURI_APP_URL = "https://duriapp.com";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.hst.duriapp";
export const APP_STORE_URL =
  "https://apps.apple.com/in/app/duri/id6755706995";

export const CITIES = [
  "Hyderabad",
  "Bengaluru",
  "Chennai",
  "Mumbai",
  "Delhi",
  "Pune",
  "Vijayawada",
  "Visakhapatnam",
  "Tirupati",
  "Warangal",
  "Guntur",
  "Nellore",
  "Kurnool",
  "Rajahmundry",
  "Kakinada",
  "Nizamabad",
  "Mysore",
  "Hubli",
  "Mangalore",
  "Coimbatore",
  "Madurai",
  "Nagpur",
  "Ahmedabad",
  "Jaipur",
  "Lucknow",
  "Kolkata",
] as const;

export type RideCategoryTag =
  | "Student Ride"
  | "Weekend Getaway"
  | "Business Travel"
  | "Daily Commute"
  | "Holiday Special";

export type CategoryBadgeTone =
  | "violet"
  | "emerald"
  | "slate"
  | "blue"
  | "amber";

export function categoryTone(cat: string): CategoryBadgeTone {
  if (cat === "Student Ride") return "violet";
  if (cat === "Weekend Getaway") return "emerald";
  if (cat === "Business Travel") return "slate";
  if (cat === "Daily Commute") return "blue";
  if (cat === "Holiday Special") return "amber";
  return "slate";
}

export const categoryToneClass: Record<CategoryBadgeTone, string> = {
  violet: "bg-violet-100 text-violet-700",
  emerald: "bg-emerald-100 text-emerald-700",
  slate: "bg-slate-100 text-slate-700",
  blue: "bg-blue-100 text-blue-700",
  amber: "bg-amber-100 text-amber-700",
};
